import { bootstrap } from './bootstrap.js';
import { ready } from './shared/browser.js';

ready(() => {
  void bootstrap();
});
